import React, { useState } from 'react';
import { MessageSquare, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { HelpSidebar } from '@/app/components/onboarding/HelpSidebar';
import { useHelpContent } from '@/hooks/useHelpContent';
import { TOUR_STEP_IDS } from '@/lib/tour-constants';

export const FloatingChatButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { data: helpContent } = useHelpContent();

  return (
    <>
      <Button
        id={TOUR_STEP_IDS.LIVE_CHAT_BUTTON}
        onClick={() => setIsOpen(true)}
        size="lg"
        className="fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full shadow-lg bg-primary hover:bg-primary/90 text-primary-foreground"
        aria-label="Live Chat Support"
      >
        <MessageSquare className="h-6 w-6" />
      </Button>
      
      <HelpSidebar 
        isOpen={isOpen} 
        onClose={() => setIsOpen(false)}
        faqs={helpContent?.faqs}
        videoUrl={helpContent?.videoUrl}
        videoTitle={helpContent?.videoTitle}
      />
    </>
  );
};
